export interface DocumentThemeFinancialHeaderOptions {

    /* Show Job Number - displays the Job Number from the parent job */
    showJobNumber: boolean;

    /* Show Customer WO - displays the Customer WO from the parent job */
    // showCustomerWO: boolean;

    /* Show Site - displays the site from the parent Job */
    showSite: boolean;

    /* Show Reference - displays the reference */
    showReference: boolean;

    /* Allows overwriting the name quote useful for creating Estimates etc */
    entityName: string;
}


export interface DocumentThemeFinancialItemOptions {
    /* 
    Show Quantity - if false, no quantity will be displayed
     */
    showQuantity: boolean;

    /* 
    Show Unit Price - if false, no unit price will be displayed 
    */
    showUnitPrice: boolean;

    /* 
    Show Tax - if false, no adjustments will be displayed.the adjustment will either be the percentage or dollar value
    */
    showTax: boolean;

    /*
    Show Total - if false, no line total will be displayed.If true, display the tax amount of the line and the total ex tax
    */
    showTotals: boolean;

    showLocation: boolean,
    showNotes: boolean,

}

export interface DocumentThemeFinancialAppendixOptions {
    pageBreakBefore: boolean;
    showBillableItems: boolean;
    showActivities: boolean;
    showAttachments: boolean;
    showImagePreview: boolean;
}

export interface DocumentThemeFinancialOptions {
    header: DocumentThemeFinancialHeaderOptions;
    items: DocumentThemeFinancialItemOptions;
    appendix: DocumentThemeFinancialAppendixOptions;
}

export const defaultFinancialOptions = {
    header: {
        entityName: 'Sale Order',
        showJobNumber: true,
        showReference: true,
        showSite: true,
    },
    items: {
        showQuantity: true,
        showUnitPrice: true,
        showTax: true,
        showTotals: true,
    },
    appendix: {
        pageBreakBefore: true,
        showBillableItems: false,
        showActivities: false,
        showAttachments: false,
        showImagePreview: false
    }
} as DocumentThemeFinancialOptions;